import { styled } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FiUpload } from "react-icons/fi";

import { Button } from "../../../../components/Form";

const styles = makeStyles(() => ({
  dispatchesGridWrapper: {
    padding: "16px 32px",
  },
  button: {
    cursor: "pointer",
  },
  deleteButton: {
    color: "#F04438",
  },
}));

export const UploadIcon = styled(FiUpload)(() => ({
  marginRight: "8px",
}));

export const StyledButton = styled(Button)(() => ({
  minWidth: "max-content",
}));

export default styles;
